<template>
  <div class="registerContainer">
    <el-form ref="registerForm" :model="registerForm" :rules="loginRules">
      <el-form-item prop="userName">
        <el-input
          placeholder="请输入用户名"
          prefix-icon="el-icon-user-solid"
          v-model="registerForm.userName"
        ></el-input>
      </el-form-item>
      <el-form-item prop="passWord">
        <el-input
          placeholder="请输入密码"
          v-model="registerForm.passWord"
          prefix-icon="el-icon-lock"
          :type="eyeFlag ? 'text' : 'password'"
          class="passwordIcon"
        >
          <i
            slot="suffix"
            style="font-size: 18px"
            :class="[eyeFlag ? 'el-icon-view' : 'iconfont icon-biyanjing']"
            @click="eyeFlag = !eyeFlag"
          ></i>
        </el-input>
      </el-form-item>

      <el-form-item prop="repeatPassword">
        <el-input
          placeholder="请再次输入密码"
          v-model="registerForm.repeatPassword"
          prefix-icon="el-icon-lock"
          :type="eyeFlag ? 'text' : 'password'"
          class="passwordIcon"
        >
          <i
            slot="suffix"
            style="font-size: 18px"
            :class="[eyeFlag ? 'el-icon-view' : 'iconfont icon-biyanjing']"
            @click="eyeFlag = !eyeFlag"
          ></i>
        </el-input>
      </el-form-item>
    </el-form>

    <el-button
      :loading="showLoading"
      class="loginBtn"
      size="small"
      type="primary"
      @click="submit"
      >注册</el-button
    >
  </div>
</template>

<script>
import { register } from '@/api/login'

import resteForm from '@/components/elementComponents/form/index.vue'
export default {
  name: 'AccountPassword',
  components: { resteForm },
  data () {
    return {
      eyeFlag: false,
      rememberPassword: false,
      registerForm: {
        userName: '',
        passWord: '',
        repeatPassword: ''
      },
      loginRules: {
        userName: [{ required: true, message: '必填', trigger: 'blur' }],
        passWord: [{ required: true, message: '必填', trigger: 'blur' }],
        repeatPassword: [
          { required: true, message: '必填', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (
                this.registerForm.passWord == this.registerForm.repeatPassword
              ) {
                callback()
              } else {
                callback(new Error('两次密码输入不一致，请重新输入'))
              }
            },
            trigger: 'blur'
          }
        ]
      },
      showLoading: false,
      timingFlag: false,
      countDown: 60,
      timeId: null,
      dialogVisible: false
    }
  },
  // 页面加载时监听是否有记住密码
  //   beforeMount () {
  //     if (
  //       localStorage.getItem('loginInfo') != null &&
  //       Object.keys(localStorage.getItem('loginInfo')).length > 2
  //     ) {
  //       this.rememberPassword = true
  //       const loginInfo = JSON.parse(localStorage.getItem('loginInfo'))
  //       // console.log('获取本地存储loginInfo', loginInfo)
  //       this.registerForm.username = loginInfo.username
  //       this.registerForm.password = loginInfo.password
  //     } else {
  //       this.rememberPassword = false
  //     }
  //   },
  mounted () {},
  watch: {
    timingFlag (newV) {
      if (newV) {
        console.log('this.timingFlag', this.timingFlag)
        console.log('需要打开定时器')
      } else {
        console.log('需要关闭定时器')
        this.countDown = 60
      }
    }
  },
  methods: {
    async submit () {
      // 全局表单验证通过 调请求接口
      this.$refs.registerForm.validate(async val => {
        if (val) {
          console.log('验证通过')
          const { userName, passWord } = this.registerForm
          const res = await register({ userName, passWord })
          console.log('注册', res)
          if (res.code == 0) {
            this.$message.success({ message: res.message, center: true })
            this.$refs.registerForm.resetFields()
          } else {
            this.$message.error({ message: res.message, center: true })
          }
        } else {
          console.log('验证不通过')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.registerContainer {
  margin: 30px 0;
}
.rememberPassword {
  display: flex;
  justify-content: space-between;
  margin: 60px 20px;
}

.rememberPassword .rememberTxt {
  color: hsla(0, 0%, 100%, 0.5);
}
.loginBtn {
  margin-top: 36px;
  width: 100%;
  background-color: #5b83fb;
}
.loginBtn:hover {
  background-color: #5b83fb;
  font-size: 26px;
}
.el-input {
  margin-top: 10px;
  font-size: 18px;
}
::v-deep .el-input__inner {
  height: 47px;
  line-height: 47px;
}
::v-deep .el-button--small {
  font-size: 26px;
  letter-spacing: 10px;
}
.restForm {
  padding: 0 100px;
}
.restForm ::v-deep .el-input__inner {
  background-color: #0a1f5d;
  border: 2px solid #2c3f73;
  font-size: 16px;
}
.restForm ::v-deep .el-form-item__label {
  line-height: 57px;
}
.restForm ::v-deep .el-link--inner {
  line-height: 57px;
}
.codeSpsn {
  text-align: right;
}
.count-down {
  color: #1890ff;
  font-size: 14px;
  text-align: left;
  padding-left: 10px;
  line-height: 57px;
}
.passwordIcon ::v-deep .el-input__suffix,
::v-deep .el-icon-lock {
  display: flex;
  align-items: center;
}
</style>
